/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import OverviewTable from './OverviewTable'

export default () => {
  return <OverviewTable module="STORE" />
}
